module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/banistmo_panama.11988961.svg";